export default __webpack_public_path__ + "69e647136d528dfb1649862f555ebdcd.svg";